if (!customElements.get('blog-body')) {
  class BlogBody extends HTMLElement {
    selectors = {
      trigger: '[blog-body="trigger"]',
      articlesContainer: '[blog-body="articles-container"]',
      articleTemplate: '[blog-body="article-template"]',
    };

    BULK_LOAD_PAGES_LIMIT = 5; // Limit for bulk loading pages

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        trigger: this.querySelector(this.selectors.trigger),
        articlesContainer: this.querySelector(this.selectors.articlesContainer),
      };

      if (!this.elements.trigger || !this.elements.articlesContainer) return;

      this.prevOpenedPage = Number(sessionStorage.getItem("blogOpenedPage")) || null;

      this.currentPage = Number(this.elements.trigger.dataset.currentPage);
      this.totalPages = Number(this.elements.trigger.dataset.totalPages);
      this.baseUrl = this.elements.trigger.dataset.url;

      if (this.prevOpenedPage && this.prevOpenedPage <= this.totalPages && this.prevOpenedPage < this.BULK_LOAD_PAGES_LIMIT) {
        for (let index = this.currentPage + 1; index <= this.prevOpenedPage; index++) {
          this.loadNextPage(index, false);
        }
      }

      if (this.currentPage == this.totalPages) {
        this.elements.trigger.style.display = 'none';
      }

      this.elements.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    }

    handleTriggerClick() {
      const nextPage = this.currentPage + 1;

      this.loadNextPage(nextPage);
    }

    loadNextPage(nextPage, updateSession = true) {
      fetch(`${this.baseUrl}&page=${nextPage}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newArticles = doc.querySelectorAll(`${this.selectors.articlesContainer} .card-article`);

          newArticles.forEach(article => {
            this.elements.articlesContainer.appendChild(article);
          });

          // Update current page
          this.currentPage = nextPage;
          updateSession && sessionStorage.setItem("blogOpenedPage", this.currentPage);

          // Hide button if last page
          if (nextPage >= this.totalPages) {
            this.elements.trigger.style.display = 'none';
          }
        })
        .catch(err => {
          console.error('Error loading more articles:', err);
        });
    }
  }
  customElements.define('blog-body', BlogBody);
}
